import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';
import axios from 'axios';

class FirebaseMessagingService {
  constructor() {
    this.token = null;
    this.isInitialized = false;
  }

  async initialize() {
    if (!Capacitor.isNativePlatform()) {
      console.log('Firebase Messaging: Not on native platform, skipping');
      return;
    }

    try {
      console.log('Firebase Messaging: Initializing...');

      // Request notification permissions
      const permissionResult = await FirebaseMessaging.requestPermissions();
      console.log('Firebase Messaging: Permission result:', permissionResult);

      if (permissionResult.receive === 'granted') {
        // FORCE REFRESH: Delete old token to ensure we get a fresh one
        try {
          await FirebaseMessaging.deleteToken();
          console.log('Firebase Messaging: Old token deleted, requesting new token...');
        } catch (deleteError) {
          console.log('Firebase Messaging: No old token to delete or delete failed:', deleteError.message);
        }

        // Get fresh FCM token
        const result = await FirebaseMessaging.getToken();
        this.token = result.token;
        console.log('Firebase Messaging: FCM Token (fresh):', this.token);

        // Send token to backend immediately
        await this.sendTokenToBackend(this.token);

        // Add listener for token refresh
        await FirebaseMessaging.addListener('tokenReceived', (event) => {
          console.log('Firebase Messaging: Token refreshed:', event.token);
          this.token = event.token;
          this.sendTokenToBackend(event.token);
        });

        // Add listener for notifications
        await FirebaseMessaging.addListener('notificationReceived', (event) => {
          console.log('Firebase Messaging: Notification received:', event);
        });

        await FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
          console.log('Firebase Messaging: Notification action performed:', event);
        });

        this.isInitialized = true;
        return this.token;
      } else {
        console.warn('Firebase Messaging: Permission not granted');
        return null;
      }
    } catch (error) {
      console.error('Firebase Messaging: Initialization error:', error);
      return null;
    }
  }

  async sendTokenToBackend(token) {
    try {
      const userToken = localStorage.getItem('token') || localStorage.getItem('accessToken');
      const userId = localStorage.getItem('userId');

      if (!userToken || !userId) {
        console.log('Firebase Messaging: No user credentials, skipping backend update');
        return;
      }

      // Update user's FCM token in backend
      const apiUrl = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_URL;
      console.log('Firebase Messaging: Sending token to:', `${apiUrl}/user/firebase-token`);

      const response = await axios.put(
        `${apiUrl}/user/firebase-token`,
        {
          userId: userId,
          firebaseToken: token
        },
        {
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        }
      );

      console.log('Firebase Messaging: Token sent to backend:', response.data);
    } catch (error) {
      console.error('Firebase Messaging: Failed to send token to backend:', error);
    }
  }

  getToken() {
    return this.token;
  }

  isReady() {
    return this.isInitialized;
  }
}

// Export singleton instance
export const firebaseMessaging = new FirebaseMessagingService();
export default firebaseMessaging;
